import { useId } from "react";
import type { FusionPipelineModel } from "../utils/fusionPipeline";
import styles from "./FusionPipelinePreview.module.css";

export function FusionPipelinePreview({
  model,
}: {
  model: FusionPipelineModel;
}) {
  const headingId = useId();

  return (
    <section className={styles.preview} aria-labelledby={headingId}>
      <h4 id={headingId} className={styles.title}>
        How this retrieve will run
      </h4>

      {!model.ready ? (
        <p className={styles.empty}>
          Select a knowledge base to see how many chunks this retrieve can
          pull.
        </p>
      ) : (
        <>
          <p className={styles.formula}>{model.formula}</p>
          {model.rerankPoolCostWarning && (
            <p className={styles.warning} role="status">
              {model.rerankPoolCostWarning}
            </p>
          )}
          <p className={styles.note}>{model.searchesNote}</p>
          <ol className={styles.steps}>
            {model.steps.map((step) => (
              <li key={step.id} className={styles.step}>
                <span className={styles.count}>{step.countLabel}</span>
                <div>
                  <p className={styles.stepTitle}>{step.title}</p>
                  <p className={styles.stepDetail}>{step.detail}</p>
                </div>
              </li>
            ))}
          </ol>
        </>
      )}
    </section>
  );
}
